import api from './apiService';

export const getTelegramVinculo = async () => {
  const { data } = await api.get('/mensagens/vinculos/telegram/');
  return data;
};

export const gerarLinkTelegram = async ({ force = false } = {}) => {
  const { data } = await api.post('/mensagens/vinculos/telegram/', { force });
  return data;
};

export const desvincularTelegram = async () => {
  await api.delete('/mensagens/vinculos/telegram/');
};

export const atualizarPreferenciasTelegram = async (payload) => {
  const { data } = await api.patch('/mensagens/vinculos/telegram/', payload);
  return data;
};
